export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/vertical-divider.1143bb30.svg","height":56,"width":2};